import React from 'react';
import { connect } from 'react-redux';
import styles from './Tabs.module.css';
import { PatientTab } from 'PatientCareCenter';



class PatientTabs extends React.Component {

    render() {
        var tabCount = Object.keys(this.props.patients).length;
        return (
            <div style={{ width: '100%' }}>
                <span className={styles.tab_container + ' ' + (tabCount > 7 ? styles.tab_container_wide : '')} >

                    {Object.keys(this.props.patients)
                        .sort((a, b) => {
                            if (!this.props.patients[a].lastName || !this.props.patients[a].firstName) {
                                return 1;
                            } else {
                                if (this.props.patients[a].lastName === this.props.patients[b].lastName) {
                                    if (this.props.patients[a].firstName === this.props.patients[b].firstName) {
                                        return this.props.patients[a].id > this.props.patients[b].id ? 1 : -1;
                                    } else {
                                        return this.props.patients[a].firstName.localeCompare(this.props.patients[b].firstName);
                                    }
                                } else {
                                    return this.props.patients[a].lastName.localeCompare(this.props.patients[b].lastName)
                                }
                            }
                        })
                        .map(id => {
                            const result = this.props.patients[id];
                            return <PatientTab key={result.id} id={result.id} selected={result.id === this.props.selectedPtno ? true : false} />
                        })
                    }
                    {tabCount <= 7 && <span className={styles.tab_white_space} />}
                </span>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        patients: state.entities.patients,
        selectedPtno: state.ui.patients.selectedPtno
    };
}


const connectedPatientTabs = connect(mapStateToProps)(PatientTabs);
export { connectedPatientTabs as PatientTabs };

